import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import PropTypes from 'prop-types';
import {useMemo} from 'react';

const HeaderCheckBox = ({
  checkedRows,
  setCheckedRows,
  idfieldname,
  rows = [],
  totalRows = 0,
}) => {
  const areAllPageRowsSelected = useMemo(() => {
    if (rows.length === 0) return false;
    return rows.every((row) => checkedRows.includes(row[idfieldname]));
  }, [rows, checkedRows, idfieldname]);

  const isIndeterminate =
    checkedRows.length > 0 && checkedRows.length < totalRows;
  const isAllSelected = totalRows > 0 && checkedRows.length === totalRows;

  const handleHeaderCheckbox = (event) => {
    const isChecked = event.target.checked;

    if (isChecked) {
      const currentPageIds = rows.map((row) => row[idfieldname]);
      const newSelection = Array.from(
        new Set([...checkedRows, ...currentPageIds]),
      );
      setCheckedRows(newSelection);
    } else {
      setCheckedRows([]);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center', // Precisely centers the checkbox vertically
        justifyContent: 'center',
        height: '100%', // Ensures it fills the TableCell height
      }}
    >
      <Checkbox
        sx={{
          color: (theme) => theme.palette.text.disabled,
          padding: 0,
          lineHeight: 0,
          '& .MuiSvgIcon-root': {
            fontSize: '1.2rem',
          },
        }}
        color='primary'
        indeterminate={!isAllSelected && isIndeterminate}
        checked={isAllSelected || areAllPageRowsSelected}
        onChange={handleHeaderCheckbox}
      />
    </Box>
  );
};

HeaderCheckBox.propTypes = {
  idfieldname: PropTypes.string.isRequired,

  checkedRows: PropTypes.array.isRequired,
  setCheckedRows: PropTypes.func,

  rows: PropTypes.array,
  totalRows: PropTypes.number,
};

export default HeaderCheckBox;
